import React from "react";
import styles from "./index.module.scss";
import Share2Icon from "../../../icons/share-2.icon";
import cn from "../../../../Utils/class-names.utils";
import { getMockStatsData } from "./mock.data";

export interface StatCardData {
  title: string;
  badge?: {
    text: string;
    bgColor: string;
    textColor: string;
  };
  value: string;
  unit: string;
  footer?: {
    text: string;
    icon?: React.ReactNode;
    textColor?: string;
  };
  showShareIcon?: boolean;
}

const OverviewDetails = () => {
  const statsData = getMockStatsData(styles);

  return (
    <div className={styles.container}>
      {statsData.map((stat, index) => (
        <article key={index} className={styles.card}>
          <header className={styles.header}>
            <div className={styles.headerContent}>
              <h2 className={styles.title}>{stat.title}</h2>

              {stat.badge && (
                <span
                  className={`${styles.badge} ${stat.badge.bgColor}`}
                >
                  <span className={styles.badgeContent}>
                    <span
                      className={`${styles.badgeText} ${
                        stat.badge.textColor
                      }`}
                    >
                      {stat.badge.text}
                    </span>
                  </span>
                </span>
              )}
            </div>

            {stat.showShareIcon && (
              <button
                type="button"
                aria-label="Share subscription details"
                className={cn(styles.shareButton, 'my-button')}
              >
                <Share2Icon className="f-grey" />  
              </button>
            )}
          </header>

          <div className={styles.valueContainer}>
            <p className={styles.value}>{stat.value}</p>

            {stat.unit && (
              <div
                className={`${styles.unitContainer} ${
                  index === 1 ? styles.unitContainerWithMargin : ""
                }`}
              >
                <span className={styles.unit}>{stat.unit}</span>
              </div>
            )}
          </div>

          {stat.footer && (
            <footer className={cn(styles.footer, stat.footer.textColor)}>
              {stat.footer.icon}
              <p
                className={`${styles.footerText} ${
                  stat.footer.textColor
                }`}
              >
                {stat.footer.text}
              </p>
            </footer>
          )}
        </article>
      ))}
    </div>
  );
};

export default OverviewDetails;
